import {
  $authorsTableSearchInputValue,
  AuthorsTable,
  AuthorsTableGate,
  authorsTableQuery,
  authorsTableSearchChanged,
} from '@/entities/authors'
import { ROUTES, STRINGS } from '@/shared/config'
import {
  ContentWrapper,
  EmptyContent,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { PrimaryButton } from '@/shared/ui'
import { AuthorForm, authorFormModalOpened } from '@/widgets/AuthorForm'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Flex, Input, Space } from 'antd'
import { Typography } from 'antd'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router-dom'

import {
  $authorsListPageLatestFilters,
  $authorsListPageLatestPage,
  $authorsListPageLatestPageSize,
  $authorsListPageLatestSearch,
  $authorsListPageLatestSort,
  AuthorsListPageGate,
} from './model/authors-list.model'

const { Text } = Typography

export function AuthorsListPage() {
  const navigate = useNavigate()

  const latestSearch = useUnit($authorsListPageLatestSearch)
  const latestSort = useUnit($authorsListPageLatestSort)
  const latestFilters = useUnit($authorsListPageLatestFilters)
  const latestPage = useUnit($authorsListPageLatestPage)
  const latestPageSize = useUnit($authorsListPageLatestPageSize)

  const { data, error, pending } = useUnit(authorsTableQuery)

  const search = useUnit($authorsTableSearchInputValue)
  const changeSearch = useUnit(authorsTableSearchChanged)

  const openAuthorFormModal = useUnit(authorFormModalOpened)

  return (
    <>
      <AuthorsListPageGate />
      <AuthorsTableGate
        initialFilters={latestFilters}
        initialPage={latestPage}
        initialPageSize={latestPageSize}
        initialSort={latestSort}
        initialSearch={latestSearch}
      />
      <AuthorForm isModal />
      <HeaderContent
        title="Авторы"
        description="Здесь можно просматривать список артистов, управлять их профилями, а также добавлять, редактировать или удалять информацию."
        buttonSlot={
          <PrimaryButton
            onClick={() => openAuthorFormModal()}
            icon={<PlusOutlined />}
          >
            Создать
          </PrimaryButton>
        }
      />

      <ContentWrapper>
        <Flex
          justify="space-between"
          align="center"
          style={{ marginBottom: 24 }}
        >
          <Text style={{ fontWeight: 600 }}>Список авторов</Text>
          <Space>
            <Input
              placeholder={STRINGS.placeholder_search_by_name_input}
              allowClear
              addonAfter={<SearchOutlined />}
              value={search || ''}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const searchString = event.target.value
                changeSearch(searchString)
              }}
              style={{
                minWidth: 300,
              }}
            />
          </Space>
        </Flex>
        <HidingSpin spinning={pending || (!data?.items && !error)}>
          {data?.items && data.items.length > 0 ? (
            <AuthorsTable
              onEdit={(authorId: string) => {
                void navigate(ROUTES.AUTHORS.EDIT.replace(':id', authorId))
              }}
            />
          ) : search?.length && search?.length > 0 ? (
            <EmptyContent description={STRINGS.nothing_was_found} />
          ) : (
            <EmptyContent description="В списке пока нет ни одного исполнителя" />
          )}
        </HidingSpin>
      </ContentWrapper>
    </>
  )
}
